import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import styles from './SearchHit.styles.css';
import ShadowWrapper from '../ShadowWrapper/ShadowWrapper.jsx';
import classNames from 'classnames';
import { truncate } from '../../lib/utils';
import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({ html: true, linkify: true, typographer: true });

const SearchHit = (props) => {
  let { theme = 'page', title, category, body, url, image, author } = props;

  const serviceTimesAttr = props['data-service-times'] || props.serviceTimes;
  const appleMusicUrl = props['apple-music-url'] || '';
  const spotifyUrl = props['spotify-url'] || '';

  const [parsedServiceTimes, setParsedServiceTimes] = useState([]);

  useEffect(() => {
    if (typeof serviceTimesAttr === 'string') {
      try {
        const parsed = JSON.parse(decodeURIComponent(serviceTimesAttr));
        setParsedServiceTimes(parsed);
      } catch (e) {
        console.error('Error parsing serviceTimes:', e);
      }
    } else if (Array.isArray(serviceTimesAttr)) {
      setParsedServiceTimes(serviceTimesAttr);
    }
  }, [serviceTimesAttr]);

  if (category === 'album' || category === 'song') {
    url = appleMusicUrl || spotifyUrl || url;
  }

  const renderServiceTimes = () => {
    if (!parsedServiceTimes || parsedServiceTimes.length === 0) {
      return null;
    }
    return (
      <div className="service-times">
        {parsedServiceTimes.map((st, index) => (
          <div key={index} className="service-time">
            <strong>{st.serviceTimeLabel}</strong>
            {st.serviceTimes &&
              Array.isArray(st.serviceTimes) &&
              st.serviceTimes.map((time, idx) => <div key={idx}>{time}</div>)}
          </div>
        ))}
      </div>
    );
  };

  const renderMusicLink = (url, filename, altText) => {
    return (
      <a href={url} className="music-icon-link">
        <img src={`/unified_assets/music_icons/${filename}`} alt={altText} />
      </a>
    );
  };

  const classes = classNames('container', {
    ['theme_modal']: theme === 'modal',
    ['theme_page']: theme === 'page',
    ['no_border']: theme === 'page',
    ['with_image']: !!image,
    ['page_with_image']: theme === 'page' && !!image
  });

  const showAuthor =
    author &&
    (category === 'article' ||
      category === 'message' ||
      category === 'video' ||
      category === 'podcast');

  const renderBody = () => {
    if (!body || body === 'undefined') {
      return null;
    }
    const parsedBody = md.render(body);
    if (theme === 'modal') {
      return (
        <p
          className={styles.body}
          dangerouslySetInnerHTML={{ __html: truncate(parsedBody, 180) }}
        />
      );
    } else if (theme === 'page') {
      return <p className={styles.body} dangerouslySetInnerHTML={{ __html: parsedBody }} />;
    }
  };

  const searchHitElement = (
    <a href={url} className={classes}>
      <div className="content">
        {theme === 'modal' && (
          <span className={styles.category}>
            {category}
            {showAuthor && <span className="author"> by {author}</span>}
          </span>
        )}
        <h2 className={theme === 'page' ? 'page-title' : 'modal-title'}>{title}</h2>
        {theme === 'page' && (
          <span className={styles.category}>
            {category}
            {showAuthor && <span className="author"> by {author}</span>}
          </span>
        )}
        {renderBody()}
        {category === 'location' && renderServiceTimes()}
      </div>
      {image && (
        <div className="image_container">
          <img src={image} alt={title} />
        </div>
      )}
    </a>
  );

  return (
    <ShadowWrapper styles={styles}>
      <div className="padding-container">
        {searchHitElement}
        <div className="music-link-container">
          {appleMusicUrl.trim() !== '' &&
            renderMusicLink(
              appleMusicUrl,
              'Apple_Music_Icon_RGB_sm_073120.svg',
              'Apple Music Icon'
            )}
          {spotifyUrl.trim() !== '' &&
            renderMusicLink(spotifyUrl, 'Spotify_Primary_Logo_RGB_Green.png', 'Spotify Icon')}
        </div>
      </div>
    </ShadowWrapper>
  );
};

export default SearchHit;
